import * as React from 'react';

import {Body} from 'shells/typography/body';

import styles from './header.module.css';

export function Header() {
    return (
        <div className={styles.header}>
            <Body as='div' size='large' isBold={true}>
                Select a phone number for SMS
            </Body>
            <Body as='div'>
                Sending texts from Nutshell requires a new phone number that we provide. Enter an
                area code and select number that looks good to you.
            </Body>
        </div>
    );
}
